import dayjs from 'dayjs';
import { useMemo } from 'react';

export function getDayString(): string {
  const date = dayjs();
  return `${date.format('YYYY-MM-DD')}-${date.day()}`;
}

export function getBonusRoundSeedName(roundName: string): string {
  return `${roundName}-bonus-round`;
}

export function useDailySeed(isArchive: boolean, roundName = ''): string {
  return useMemo(
    () =>
      isArchive
        ? `archive${roundName ? `-${roundName}` : ''}`
        : `${getDayString()}${roundName ? `-${roundName}` : ''}`,
    [roundName, isArchive],
  );
}
